import { Dashboard } from "../../models/Dashboard";
import DocumentList from "../genericcrud/DocumentList";
const DashboardMaster = () => {
  return (
    <>{<DocumentList documentMeta={Dashboard}/>}</>
  );
};

export default DashboardMaster;
